import {Style, Fill, Stroke, Circle} from 'ol/style.js';
import {transformExtent} from 'ol/proj';
import {GeoJsonLayer} from '../GeoJsonLayer.js';
import Library from '../Library.js';

export class MisLayer extends GeoJsonLayer {

    constructor( map, settings = {}){
        settings["name"] = 'mis';
        settings["dynamic_time"] = true;
        settings["api_endpt"] = "MisJSON.php";
        super( map, settings );
    }

    getUrl( extent, resolution, projection ){
        let extent1 = transformExtent(extent, projection, "EPSG:4326");
        let url = new URL( this.api_path + "/" + this.api_endpt );
        url.searchParams.set( "bbox", extent1.join(","));
        url.searchParams.set( "zoom", this.map.view.getZoom());
        url.searchParams.set( "date", Library.formatDate( "ymd_hn", this.map.secs ));
        return url.toString();
    }

    getColor( feature ){
        return "#CCAA00";
    }

    getLineColor( feature ){
        return "#884400";
    }

    getHighlightColor( feature ){
        return "#CCCCCC";
    }

    getOpacity(feature){
        return this.options['opacity'];
    }

    getPopupText( feature ){
        let text = this.popupTitle( "MIS", "Impact Statement");
        text += this.popupData( "CWSU", this.property(feature,'cwsu')+
            " ["+this.property(feature,'name')+"]" );
        text += this.popupData( "Begins", this.property(feature,'valid_time_from') );
        text += this.popupData( "Ends", this.property(feature,'valid_time_to') );
        text += this.popupSep();
        let mis = this.property(feature,'mis_text');
        mis = mis.replace( /\n/g, "<br/>" );
        text += this.popupData( "", mis );
        text += this.popupEnd();
        return text;
    }

    getSize(feature){
        return 5;
    }

    getStyle(feature, resolution ){
        let style = new Style({
                "image": new Circle({
                    "radius": this.getSize(feature),
                    "fill": new Fill({
                        "color": Library.parseHexColorToArray(this.getColor(feature), 0.5 )
                        }),
                    "stroke": new Stroke({
                        "color": Library.parseHexColorToArray(this.getLineColor(feature), 1.0 ),
                        "width": 2
                        })
                })
            });
        return style;
    }
}
